import type { SportEventModule } from '../types';
import { parseNbaEvent } from './parser';
import { describeNbaEvent } from './descriptions';
import { NBA_EVENT_TYPES } from './eventTypes';
import { NBA_STATS } from './stats';
import { nbaFeaturedParticipantIds } from './featured';
import { ScoreEventItem } from '../../components/ScoreEventItem';

// Made scoring plays render with the inline running-score row (ScoreEventItem)
// instead of the generic RegularEventItem. Missed attempts keep the default
// row — only a made basket / free throw puts a point on the board.
const NBA_SCORE_RENDERER_TYPES = new Set([
  'basket_made_2pt',
  'basket_made_3pt',
  'free_throw_made',
]);

export const NBA_SPORT_MODULE: SportEventModule = {
  id: 'NBA',
  displayName: 'NBA',
  objectOfPlayLabel: 'Ball',
  parseEvent: parseNbaEvent,
  describeEvent: describeNbaEvent,
  eventTypes: NBA_EVENT_TYPES,
  stats: NBA_STATS,
  featuredParticipantIds: nbaFeaturedParticipantIds,
  pickRenderer(event) {
    const type = (event.payload as any)?.type;
    return type && NBA_SCORE_RENDERER_TYPES.has(type) ? ScoreEventItem : undefined;
  },
};
